import { App, Steps , Button, Card, Col, Collapse, DatePicker, Divider, Flex, Form, Input, message, Modal, Row, Select, Table, Tag, Popover, StepsProps, Progress, TablePaginationConfig } from "antd";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { CommitteeProject, ProjectInfoInterface } from "../model/IprojectInfo";
import { motion, AnimatePresence } from 'framer-motion';
import {
    SearchOutlined,
    DeleteOutlined,
    ShrinkOutlined
} from '@ant-design/icons';
import { CommitteeList } from "../model/CommitteeList";
import { FacilityInterface } from "../model/IFac"
import dayjs from "dayjs";
import editingRequest from "../img/IMG_7283.png"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, TooltipProps, BarChart, Bar, Rectangle, PieChart, Pie } from 'recharts';
import imgdata2 from '../components/img/writing.gif'
import filling from '../components/img/Filling.gif'
import checking from '../components/img/Checking.gif'
import reviewing from '../components/img/Reviewing.gif'
import signing from '../components/img/Signing.gif'

interface Summary {
    name:string
    จำนวนคำขอที่ยื่นในระบบ: number;
    จำนวนนักวิจัยที่ยื่นโครงการในระบบ: number;
    จำนวนบุคลากรที่ยื่นโครงการในระบบ: number;
    จำนวนนักศึกษาที่ยื่นโครงการในระบบ: number;
    จำนวนอาจารย์ที่ยื่นโครงการในระบบ: number;
    โครงการที่ถูกอนุมัติ: number;
    โครงการที่ไม่อนุมัติ: number;
  }


  
export function Home(){
    const {notification} = App.useApp();
    const navigate = useNavigate();
    const [CommitteePagination, setCommitteePagination] = useState<{
        current: number;
        pageSize: number;
      }>({
        current: 1,
        pageSize: 10,
      });
    const CustomDotProgress = (PJstatus:string) =>(
        <>
            <Popover
                content={
                    <span>
                        <p>{PJstatus}</p>

                    </span>
                }
            >
            </Popover>
        </>
    )

    const customDot = (
        dot: React.ReactNode,
        { status, index }: { status: string; index: number },
        record: any,currentStep:any
      ) => (
        <>  
            {
                (currentStep==index)&&<Popover
                    content={<span>
                        {record.project_status=='แก้ไข'&&<> 
                        {/* <img src={imgdata2} alt="loading..." /> */}
                            <p>กำลังแก้ไขคำขอโดยนักวิจัย</p></>}
                        
                        {record.project_status=='แก้ไขข้อมูลตามผลพิจารณา'&&<p>กำลังแก้ไขคำขอตามการพิจารณาของกรรมการ</p>}
                        {record.project_status=='แก้ไข'&&<> 
                            <p>กำลังแก้ไขคำขอโดยนักวิจัย</p></>}
                            {record.project_status=='แก้ไข'&&<> 
                                <p>กำลังแก้ไขคำขอโดยนักวิจัย</p></>}
                                {record.project_status=='แก้ไข'&&<> 
                                    <p>กำลังแก้ไขคำขอโดยนักวิจัย</p></>}
                    </span>}
                >
                    {dot}
                </Popover>||
                <>{dot}</>}
        </>
      );

    const [form] = Form.useForm();
    const [CommitteeList,setCommitteeList] = useState<CommitteeList[]>([])
    const [CommitteeSummarList,setCommitteeSummaryList] = useState<CommitteeProject[]>([])
    const [CommitteeSubmittedList,setCommitteeSubmittedList] = useState <CommitteeList[]>([])
    const [getData,setGetData] = useState<ProjectInfoInterface[]>([]);
    const [getShowData,setGetShowData] = useState<ProjectInfoInterface[]>([]);
    const [EditFilter,setEditfilter] = useState(false);
    const [CheckFilter,setCheckfilter] = useState(false);
    const [ReviewFilter,setReviewfilter] = useState(false);
    const [FinishedFilter,setFinishedfilter] = useState(false);
    let StatusList = [
        {
            title: 'นักวิจัย',
            description:'',
        },
        {
            title: 'เจ้าหน้าที่',
            description:'',
        }, {
            title: 'ประธาน',
            description:'',
        }, {
            title: 'กรรมการ',
            description:'',
        }
    ]
    const [Fac,setFac] = useState<FacilityInterface[]>([]);

    function nextPage(ID:any,head_ID:any,project_status:any){
        sessionStorage.setItem('Order_ID',ID)
        sessionStorage.setItem('head_ID',head_ID)
        if(sessionStorage.getItem('role')=='researcher'){
            setTimeout(() => {
            navigate(`/VU_HREC/ProjectInfo/`)
            }, 100);
        }
        else if (sessionStorage.getItem('role')=='staff'){
            
            setTimeout(() => {
               navigate(`/VU_HREC/StaffProjectInfo`)
              }, 100);}
        else if (sessionStorage.getItem('role')=='committee'){navigate(`/VU_HREC/RequestReview`)}
    }

    async function deleteProject(){
        await axios.delete(`${process.env.REACT_APP_BASE}/DeleteProject/${sessionStorage.getItem('user')}/${sessionStorage.getItem('Order_ID')}`).then(response=>{
            if(response.status==200){
                window.location.reload();
            }else{
                notification.error({message:'ลบโครงการไม่สำเร็จ กรุณาติดต่อเจ้าหน้าที่'})
            }
        })
    }
    
    const [deletionMod,setDeletionMod] = useState(false);
    const [RequestView,setRequestView] = useState(false)
    const [CommitteeSummaryReportView,setCommitteeSummaryReportView] = useState(false)
    const [CommitteeView,setCommitteeView] = useState(false)
    const [CommitteeSummaryView,setCommitteeSummaryView] = useState(false)
    const [YearType,setYearType] = useState()
    const [summary_data,setSummarydata]=useState<Summary[]>([]);
    const [Year,setYear] = useState()

    async function closeall(){
        setRequestView(false)
        setCommitteeView(false)
        setCommitteeSummaryView(false)
        setCommitteeSummaryReportView(false)
    }

    async function resetSearch(){
        await axios.get(`${process.env.REACT_APP_BASE}/GetDataForStaff`).then(response=>{
            if(response.status==200){
                setGetData(response.data)
                setGetShowData(response.data)
            }
        })
    }

    async function ProjectSearch(){
        const SearchData = form.getFieldsValue();
        const SearchedFilter ={
            ProjectNameTH:SearchData.thProjectname,
            ProjectNameEN:SearchData.enProjectname,
            ResearcherTHName:SearchData.researcher_thname,
            ResearcherENName:SearchData.researcher_enname,
            ResearcherStatus:SearchData.status,
            ResearcherPosition:SearchData.position,
            ResearcherFac:SearchData.facility,
            SearchYear:SearchData.SearchYear,

        }
        await axios.post(`${process.env.REACT_APP_BASE}/SearchForStaff`,SearchedFilter).then((response)=>{
            if(response.status==200){
                setGetData(response.data);;
                setGetShowData(response.data);
            }
        })
    }


    useEffect(()=>{
        if(sessionStorage.getItem('role')=='researcher')
        {axios.get(`${process.env.REACT_APP_BASE}/getProjectlist/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status==200)
                {
                    setGetData(response.data)
                }
        })}
        else if(sessionStorage.getItem('role')=='staff'){
            axios.get(`${process.env.REACT_APP_BASE}/GetDataForStaff`).then(response=>{
                if(response.status==200){
                    const tmpdata = response.data

                    setGetData(tmpdata)
                    setGetShowData(tmpdata)

                    const currentYear = new Date().getFullYear();

                    // Helper: return month+year string (in Thai)
                    const getYearMonth = (dateString: string | null) => {
                    if (!dateString) return "ไม่ระบุ";
                    const d = new Date(dateString);

                    return d.toLocaleDateString("th-TH", {
                        month: "long",
                        year: "numeric",
                    });
                    };

                    // Group data
                    const grouped: { [month: string]: Summary } = {};

                    tmpdata.forEach((item: any) => {
                    if (!item.last_submitted) return;

                    const d = new Date(item.last_submitted);
                    
                    if (d.getFullYear() !== currentYear) return; // ✅ keep only this year

                    const month = getYearMonth(item.last_submitted);
                    

                    if (!grouped[month]) {
                        grouped[month] = {
                        name: month,
                        จำนวนคำขอที่ยื่นในระบบ: 0,
                        จำนวนนักวิจัยที่ยื่นโครงการในระบบ: 0,
                        จำนวนบุคลากรที่ยื่นโครงการในระบบ: 0,
                        จำนวนนักศึกษาที่ยื่นโครงการในระบบ: 0,
                        จำนวนอาจารย์ที่ยื่นโครงการในระบบ: 0,
                        โครงการที่ถูกอนุมัติ: 0,
                        โครงการที่ไม่อนุมัติ: 0,
                        };
                    }else{
                        console.log('duplicate month found')
                        console.log(grouped[month])
                    }

                    if (item.project_status !== "แก้ไข") {
                        grouped[month].จำนวนคำขอที่ยื่นในระบบ++;
                    }
                    if (item.posname === "บุคลากร") {
                        grouped[month].จำนวนบุคลากรที่ยื่นโครงการในระบบ++;
                    }
                    if (
                        item.posname === "นักศึกษาระดับปริญญาตรี" ||
                        item.posname === "นักศึกษาระดับปริญญาโท" ||
                        item.posname === "นักศึกษาระดับปริญญาเอก"
                    ) {
                        grouped[month].จำนวนนักศึกษาที่ยื่นโครงการในระบบ++;
                    }
                    if (item.posname === "อาจารย์") {
                        grouped[month].จำนวนอาจารย์ที่ยื่นโครงการในระบบ++;
                    }
                    if (item.project_status === "ได้รับหนังสือรับรองจากอธิการบดี") {
                        grouped[month].โครงการที่ถูกอนุมัติ++;
                    }
                    if (item.project_status === "ไม่อนุมัติ") {
                        grouped[month].โครงการที่ไม่อนุมัติ++;
                    }
                    });

                    // Unique researchers
                    Object.keys(grouped).forEach((month) => {
                    const uniqueResearchers = new Set(
                        tmpdata
                        .filter(
                            (item: any) =>
                            item.last_submitted &&
                            getYearMonth(item.last_submitted) === month &&
                            new Date(item.last_submitted).getFullYear() === currentYear
                        )
                        .map((item: any) => item.headID)
                    ).size;

                    grouped[month].จำนวนนักวิจัยที่ยื่นโครงการในระบบ = uniqueResearchers;
                    });

                    // Convert to array and sort by month order
                    const monthOrder = [
                    "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
                    "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
                    "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
                    ];

                    const formatted: Summary[] = Object.values(grouped).sort((a, b) => {
                    const aMonth = monthOrder.findIndex((m) => a.name.includes(m));
                    const bMonth = monthOrder.findIndex((m) => b.name.includes(m));
                    return aMonth - bMonth;
                    });

                    console.log(formatted)

                    setSummarydata(formatted);


    
                        
                }
            })
            axios.get(`${process.env.REACT_APP_BASE}/GetCommitteeList`).then((response)=>{
                if(response.status==200){
                    setCommitteeList(response.data)
                }
            })
            axios.get(`${process.env.REACT_APP_BASE}/ReviewList`).then((response)=>{
                if(response.status==200){
                    setCommitteeSummaryList(response.data)
                    setCommitteeSubmittedList(
                        response.data.filter(
                          (item: any, index: number, self: any[]) =>
                            index === self.findIndex((t) => t.CommitteeName === item.CommitteeName)
                        )
                      );
                }
            })
        }
        else
        {
            axios.get(`${process.env.REACT_APP_BASE}/getDataForCommittee/${sessionStorage.getItem('user')}`).then((response)=>{
                if(response.status==200){
                    setGetData(response.data)
                }
            })
        }
    },[])

    if(sessionStorage.getItem('role')=='staff')
    {

        const exportToExcel = () => {
            // Prepare data to export
            const data = CommitteeSubmittedList.map((record, index) => {
              const relatedProjects = CommitteeSummarList.filter(
                (item) => item.CommitteeName === record.CommitteeName
              );
          
              return {
                ลำดับ: index + 1,
                รายชื่อกรรมการ: record.CommitteeName,
                รายชื่อโครงการพิจารณา: relatedProjects
                  .map(
                    (item, idx) =>
                      `${idx + 1}. ${item.project_nameTH} (${item.project_nameEN}) โดย ${item.researcher_THname} (${item.researcher_ENname})`
                  )
                  .join("\n"), // put in one cell with line breaks
                "จำนวนโครงการที่พิจารณา(ของนักศึกษาปริญญาโท-เอก)": relatedProjects.filter(
                  (item) =>
                    item.education_level === "ปริญญาเอก" ||
                    item.education_level === "ปริญญาโท"
                ).length,
                "จำนวนโครงการที่พิจารณา(ของนักศึกษาปริญญาตรี)": relatedProjects.filter(
                  (item) => item.education_level === "ปริญญาตรี"
                ).length,
                'จำนวนโครงการที่พิจารณา(ของอาจารย์/บุคลากรภายใน)': relatedProjects.filter(
                  (item) =>
                    item.posname === "บุคลากร" || item.posname === "อาจารย์"
                ).length,
                จำนวนโครงการที่พิจารณาทั้งหมด: relatedProjects.length,
              };
            });
          
            // Convert JSON to worksheet
            const ws = XLSX.utils.json_to_sheet(data);
          
            // Create workbook and add worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Committee Summary");
          
            // Export to file
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
            saveAs(blob, "committee_summary.xlsx");
          };
        return (<>
        <h1>รายงานภาพรวมระบบยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล</h1>
        <hr/>
        <Flex justify='center'>
          <ResponsiveContainer width="100%" height={300}>
          <LineChart data={summary_data}>
              <XAxis dataKey="name" />
              <YAxis 
                allowDecimals={false}  
                tickFormatter={(tick) => Number.isInteger(tick) ? tick : ""} 
                />
              <Tooltip />
              <Legend />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Line type="monotone" dataKey="จำนวนคำขอที่ยื่นในระบบ" stroke="#8884d8" />
              <Line type="monotone" dataKey="จำนวนนักวิจัยที่ยื่นโครงการในระบบ" stroke="blue" />
              <Line type="monotone" dataKey="โครงการที่ถูกอนุมัติ" stroke="#82ca9d" />
              <Line type="monotone" dataKey="โครงการที่ไม่อนุมัติ" stroke="red" />
            </LineChart>
          </ResponsiveContainer>
          </Flex>
        <AnimatePresence>
            <motion.div
                key="bloodCard"
                initial={{ opacity: 0, y: -20, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -20, scale: 0.9 }}
                transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}
                >
                <Row gutter={10}>
                    <Col span={6}>
                        <Card
                            style={{
                                backgroundColor:'#4834d4',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '150px', 
                            }}
                            hoverable bordered={false}
                            onClick={async ()=>{
                                await closeall();
                                setRequestView(true)
                            }
                            }
                        >
                            <p className='text-2xl font-semibold' style={{marginBottom:10}}>ดูสรุปคำขอพิจารณาจริยธรรมในระบบ</p>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card
                            style={{
                                backgroundColor:'#592494',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '150px', 
                            }}
                            hoverable bordered={false}
                            onClick={async ()=>{
                                await closeall();
                                setCommitteeSummaryReportView(true)
                            }}>
                        <p className='text-2xl font-semibold' style={{marginBottom:10}}>ดูสรุปจำนวนผู้ยื่นข้อมูลในระบบ</p>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card
                            style={{
                                backgroundColor:'#641a6a',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '150px', 
                            }}
                            hoverable bordered={false}
                            onClick={async ()=>{
                                await closeall();
                                setCommitteeView(true)
                            }}>
                            <p className='text-2xl font-semibold' style={{marginBottom:10}}>ดูรายชื่อกรรมการในระบบ</p>
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card
                            style={{
                                backgroundColor:'#6f1040',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '150px', 
                            }}
                            hoverable bordered={false}
                            onClick={async ()=>{
                                await closeall();
                                setCommitteeSummaryView(true)
                            }}>
                            <p className='text-2xl font-semibold' style={{marginBottom:10}}>ดูสรุปผลการพิจารณาของกรรมการแต่ละท่าน</p>
                        </Card>
                    </Col>
                    
                </Row>
            </motion.div>
        </AnimatePresence>
        <hr/>
        {RequestView&&<AnimatePresence>
            <motion.div
                key="bloodCard"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                >
                <Card>
                    <h2>สรุปข้อมูลคำขอที่ยื่นเข้ามาในระบบ</h2>
                    <br/>
                    <motion.div
                        key="bloodCard"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5 }}
                        >
                    <Card>
                        <Row>
                            <Col span={12}>
                                <Card
                                 style={{
                                    backgroundColor:'#687351',
                                    color:'white',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    height: '300px', 
                                }}>
                                    <h2>จำนวนคำขอทั้งหมดที่ยื่นเข้ามาในระบบ</h2>
                                    <h2>{getData?.filter((item)=>item.project_status=='แก้ไข').length}</h2>
                                </Card>
                                <Card
                                 style={{
                                    backgroundColor:'#e8e4db',
                                    color:'#954c2e',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    height: '300px', 
                                }}>
                                    <h2>จำนวนคำร้องที่มาจากภายใน</h2>
                                    <h2>{0}</h2>
                                </Card>
                            </Col>
                            <Col span={12}>
                                <Card
                                 style={{
                                    backgroundColor:'#c9c1ae',
                                    color:'#954c2e',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    height: '300px', 
                                }}>
                                    <h2>จำนวนคำขอที่ได้รับการรับรอง</h2>
                                    <h2>{0}</h2>
                                </Card>
                                <Card
                                 style={{
                                    backgroundColor:'#9ba17f',
                                    color:'white',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    height: '300px', 
                                }}>
                                    <h2>จำนวนคำขอที่มาจากภายนอก</h2>
                                    <h2>{0}</h2>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                    </motion.div>
                </Card>
            </motion.div>
        </AnimatePresence>}

        {CommitteeView&&<AnimatePresence>
            <motion.div
                key="bloodCard"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                >
                <Card>
                    <h2>รายชื่อกรรมการที่มีในระบบ</h2>
                    <Table
                        columns={[
                            {
                                title:'ลำดับ',
                                dataIndex:'CommitteeID',
                                render: (_, __, index) => {
                                  const page = CommitteePagination.current;
                                  const pageSize = CommitteePagination.pageSize;
                                  return (page - 1) * pageSize + index + 1;
                                },
                            },{
                                title:'ชื่อ',
                                dataIndex:'CommitteeName'
                            },{
                                title:'email',
                                dataIndex:'email'
                            },{
                                title:'ถูกเพิ่มเมื่อ',
                                dataIndex:'addAt',
                                render:(__, record)=><>
                                    <p> {moment.utc(record.addAt).format('DD/MM/YYYY  HH:mm:ss')}</p>
                                </>
                            }
                            ]}
                            pagination={{
                                ...CommitteePagination,
                                total: CommitteeList.length,
                              }}
                              onChange={(pagination: TablePaginationConfig) => {
                                setCommitteePagination({
                                  current: pagination.current ?? 1,   // fallback to 1 if undefined
                                  pageSize: pagination.pageSize ?? 10, // fallback to 10 if undefined
                                });
                              }}
                        dataSource={CommitteeList}/>
                </Card>
            </motion.div>
        </AnimatePresence>}

        {CommitteeSummaryView&&<AnimatePresence>
            <motion.div
                key="bloodCard"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                >
                <Card>
                    <Flex justify='space-between'><h2>สรุปผลพิจารณาของกรรมการแต่ละท่าน</h2>
                    <h2><Button onClick={exportToExcel}>ส่งออกเป็นไฟล์ Excel</Button></h2>
                    </Flex>
                    <hr/>
                    <Table columns={[
                        {
                            title:'ลำดับ',
                            render: (_: any, record: any,index:any) =>
                                <>
                                <p>{index+1}</p>
                                </>
                        },
                        {
                            title:'รายชื่อกรรมการ',
                            dataIndex:'CommitteeName'
                        },
                        {
                            title: 'รายชื่อโครงการที่พิจารณา',
                            render: (_: any, record: any) => (
                              <>
                                {CommitteeSummarList
                                  .filter((item) => item.CommitteeName === record.CommitteeName) // ✅ show only projects of this committee
                                  .map((item, index) => (
                                    <p key={index}>
                                      {index + 1}. {item.project_nameTH} ({item.project_nameEN}) โดย {item.researcher_THname}({item.researcher_ENname})
                                    </p>
                                  ))}
                              </>
                            ),
                          },
                        {
                            title:'จำนวนโครงการที่พิจารณา(ของนักศึกษาปริญญาโท-เอก)',
                            render: (_: any, record: any) => (
                              <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName&&(item.education_level=='ปริญญาเอก'||item.education_level=='ปริญญาโท'))) 
                                  .length}
                              </>
                            ),
                        },
                        {
                            title:'จำนวนโครงการที่พิจารณา(ของนักศึกษาปริญญาตรี)',
                            render: (_: any, record: any) => (
                              <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName&&(item.education_level=='ปริญญาตรี'))) 
                                  .length}
                              </>
                            ),
                        },
                        {
                            title:'จำนวนโครงการที่พิจารณา(ของอาจารย์/บุคลากรภายใน)',
                            render: (_: any, record: any) => (
                                <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName&&(item.posname=='บุคลากร'||item.posname=='อาจารย์'))) 
                                  .length}
                              </>
                            ),
                        },
                        {
                            title:'จำนวนโครงการที่พิจารณาทั้งหมด',
                            render: (_: any, record: any) => (
                                <>
                                {CommitteeSummarList
                                  .filter((item) => (item.CommitteeName === record.CommitteeName)) 
                                  .length}
                                </>
                            ),
                        }
                    ]}
                    dataSource={CommitteeSubmittedList}/>
                </Card>
            </motion.div>
        </AnimatePresence>}

        {CommitteeSummaryReportView&&<AnimatePresence>
            <motion.div
                key="bloodCard"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                >
                    
                <Card>
                    <h2>สรุปข้อมูลผู้ที่ยื่นเข้ามาในระบบ</h2>
                    <hr/>
                    <Row >
                        <Col span={12}>
                            <Card 
                            style={{
                                backgroundColor:'#cdaaa1',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '300px', 
                            }}
                            >
                                <h2>จำนวนผู้ที่ยื่นคำขอทั้งหมด</h2>
                                <h2>{
                                    getData.filter((item, index, self) =>
                                    index === self.findIndex(t => t.head_ID === item.head_ID) &&
                                    item.project_status == 'แก้ไข'
                                    ).length
                                }
                                </h2>
                            </Card>
                            <Card 
                            style={{
                                backgroundColor:'#4974a5',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                               height: '300px', 
                            }}
                          >
                                <h2>จำนวนนักศึกษาที่ยื่นคำขอ</h2>
                                <h2>{0}</h2>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card 
                            style={{
                                backgroundColor:'#7a49a5',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '300px', 
                            }}
                          >
                                <h2>จำนวนบุคลากรที่ยื่นคำ</h2>
                                <h2>{getData.filter((item, index, self) =>  index === self.findIndex((t) => (t.head_ID === item.head_ID&&t.head_ID.length==7))).length}</h2>
                            </Card>
                            <Card 
                            style={{
                                backgroundColor:'#A1C4CD',
                                color:'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                height: '300px', 
                            }}
                           >
                                <h2>จำนวนบุคคลภายนอกที่ยื่นคำขอ</h2>
                                <h2>{0}</h2>
                            </Card>
                        </Col>
                    </Row>
                </Card>
            </motion.div>
        </AnimatePresence>}
        <h1>คำขอที่มีการยื่นเข้ามาในระบบ</h1>
        <hr/>
        <Card>
              <h3><u>ฟอร์มค้นหาคำขอในระบบ</u></h3>
              <Form
                form={form}>
                <Row>
                    <Col span={11}>
                        <Form.Item name='thProjectname' label='ชื่อโครงการที่ถูกยื่น'>
                            <Input placeholder='ชื่อโครงการที่ถูกยื่นภาษาไทย' />
                        </Form.Item>
                        <Form.Item name='researcher_thname' label='ชื่อของผู้ยื่นคำขอ'>
                            <Input placeholder='ชื่อผู้ยื่นภาษาไทย' />
                        </Form.Item>
                        <Form.Item name='status' label='ประเภทผู้ยื่น'>
                            <Select placeholder='ex: ภายใน/ภายนอก'
                                options={[
                                    {value:'1',label:'ภายใน'},
                                    {value:'0',label:'ภายนอก'}
                                ]}/>
                        </Form.Item>

                        <Form.Item name='facility' label='สังกัด' >
                            <Select placeholder='เลือกสังกัดที่มีการยื่นในระบบ'/>
                        </Form.Item>
                        <Form.Item name='SearchYear' label='ปีที่ยื่นคำขอ' >
                            <DatePicker picker="year"/>
                        </Form.Item>
                    </Col>
                    <Col span={2}>
                    </Col>
                    <Col span={11}>
                        <Form.Item name='enProjectname' >
                            <Input placeholder='ชื่อโครงการภาษาอังกฤษ' />
                        </Form.Item>
                        <Form.Item name='researcher_enname' >
                            <Input placeholder='ชื่อผู้ยื่นภาษาอังกฤษ' />
                        </Form.Item>
                        <Form.Item name='position'>
                            <Select placeholder='ex: บุคลากร/นักศึกษา etc.'
                                options={[
                                    {value:'อาจารย์',label:'อาจารย์'},
                                    {value:'บุคลากร',label:'บุคลากร'},
                                    {value:'นักศึกษาระดับปริญญาตรี',label:'นักศึกษาระดับปริญญาตรี'},
                                    {value:'นักศึกษาระดับปริญญาโท',label:'นักศึกษาระดับปริญญาโท'},
                                    {value:'นักศึกษาระดับปริญญาเอก',label:'นักศึกษาระดับปริญญาเอก'},
                                    {value:'อื่นๆ',label:'อื่นๆ'}
                                ]} />
                        </Form.Item>
                      
                        
                    </Col>
                </Row>
               
                <Flex justify='flex-end'><Button type='primary' onClick={()=>resetSearch()} danger>รีเซ็ตการค้นหา</Button>&nbsp;<Button type='primary' onClick={()=>ProjectSearch()}>ค้นหา</Button></Flex>
              </Form>
        </Card>
        <br/>
        <Row>
            <Col span={6} >
                <Card onClick={()=>{
                    setReviewfilter(false)
                    setFinishedfilter(false)
                    setEditfilter(false)
                    setCheckfilter(!CheckFilter)
                    setGetShowData(getData.filter((item)=>(
                        item.project_status=='รอตรวจสอบจากเจ้าหน้าที่'||
                        item.project_status=='รอการตรวจสอบผลพิจารณา'||
                        item.project_status=='รอตรวจสอบจากประธานจริยธรรม'||
                        item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'||
                        item.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        item.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'||
                        item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี')
                    ))}} hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#6ba7fa',color:'#fdfdfd',border:'none'}}>
                    <h2 style={{ marginBottom: 0 }}>กำลังตรวจสอบ</h2>
                    <h2 style={{ marginTop: 0 }}>และแต่งตั้งจากประธาน</h2>
                    <Flex align='flex-start'  justify='center'>
                        <h1>
                            {getData.filter((item)=>(
                                item.project_status=='รอตรวจสอบจากเจ้าหน้าที่'||
                                item.project_status=='รอการตรวจสอบผลพิจารณา'||
                                item.project_status=='รอตรวจสอบจากประธานจริยธรรม'||
                                item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'||
                                item.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                item.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'||
                                item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'
                                )).length}
                        </h1>
                    </Flex>
                </Card>
            </Col>
            <Col span={6}>
                <Card onClick={()=>
                    {
                        setFinishedfilter(false)
                        setEditfilter(false)
                        setCheckfilter(false)
                        setReviewfilter(!ReviewFilter)
                        setGetShowData(getData.filter((item)=>(
                            item.project_status=='รอการพิจารณาจากกรรมการ'||
                            
                            
                            item.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )))
                    }
                    } hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#943c78',color:'#fdfdfd',border:'none'}}>
                    <h2 style={{ marginBottom: 0 }}>รอพิจารณา</h2>
                    <h2 style={{ marginTop: 0 }}>จากกรรมการ</h2>
                    <Flex align='flex-start'  justify='center'>
                        <h1>
                            {getData.filter((item)=>(
                                item.project_status=='รอการพิจารณาจากกรรมการ'||
                                item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'||
                                item.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )).length}
                        </h1>
                    </Flex>
                </Card>
            </Col>
            <Col span={6}>
                <Card onClick={()=>{
                    setCheckfilter(false)
                    setReviewfilter(false)
                    setFinishedfilter(false)
                    setEditfilter(!EditFilter)
                    setGetShowData(getData.filter((item)=>(
                        item.project_status == 'แก้ไข'||
                        item.project_status=='แก้ไขข้อมูลตามผลพิจารณา')
                    ))
                }} hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#ffc300',color:'#fdfdfd',border:'none'}}>
                    <h2 style={{ marginBottom: 0 }}>รอนักวิจัยแก้ไข</h2>
                    <h2 style={{ marginTop: 0 }}>และส่งข้อแก้ไข</h2>
                    <Flex align='flex-start'  justify='center'>
                        <h1>
                            {getData.filter((item)=>(
                            item.project_status=='แก้ไข'||
                            item.project_status=='แก้ไขข้อมูลตามผลพิจารณา')).length}
                        </h1>
                    </Flex>
                </Card>
            </Col>
            <Col span={6}>
                <Card onClick={()=>{
                    {
                        setReviewfilter(false)
                        setEditfilter(false)
                        setCheckfilter(false)
                        setGetShowData(getData.filter((item)=>(
                            item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'
                            )))
                    }
                }} hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#3C467B',color:'#fdfdfd',border:'none'}}>
                    <h2 style={{ marginBottom: 0 }}>รับรองผลพิจารณา</h2>
                    <h2 style={{ marginTop: 0 }}>&nbsp;</h2>
                    <Flex align='flex-start'  justify='center'>
                        <h1>
                            {getData.filter((item)=>(
                                item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'
                                )).length}
                        </h1>
                    </Flex>
                </Card>
            </Col>
        </Row>
        
        
        {EditFilter&&
            <AnimatePresence>
            <br/>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status == 'แก้ไข'))}>
                            <Tag color='#FFE100' >แก้ไข</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>(
                        item.project_status == 'แก้ไขข้อมูลตามผลพิจารณา'
                       )
                    ))}><Tag color='gold-inverse'>แก้ไขข้อมูลตามผลพิจารณา</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }

        {CheckFilter&&
            <AnimatePresence>
                <br/>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบจากเจ้าหน้าที่'))}>
                            <Tag color="#33A1E0" >รอตรวจสอบจากเจ้าหน้าที่</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอการตรวจสอบผลพิจารณา'))}>
                            <Tag color='#1C6EA4'>รอการตรวจสอบผลพิจารณา</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'))}>
                            <Tag color='#154D71'>รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี'))}>
                            <Tag color='#0e3c59'>รอหนังสือรับรองจากหนังสือรับรองจากอธิการบดี</Tag></a>
                    </Flex>
                    <br/>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบจากประธานจริยธรรม'))}>
                            <Tag color='#1C6EA4'>รอตรวจสอบจากประธานจริยธรรม</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'))}>
                            <Tag color="#154D71" >ประธานฯแต่งตั้งกรรมการใหม่</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'))}>
                            <Tag color='#1C6EA4'>รอตรวจสอบผลการแก้ไขจากประธาน</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }

        {ReviewFilter&&
            <AnimatePresence>
                <br/>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอการพิจารณาจากกรรมการ'))}>
                            <Tag color="#FFDFEF" style={{ color: "#d63384" }}>รอการพิจารณาจากกรรมการ</Tag></a>
                       
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='รอพิจารณากรรมการอีกครั้ง'))}>
                            <Tag color='#AA60C8' >รอพิจารณากรรมการอีกครั้ง</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }

        {FinishedFilter&&
            <AnimatePresence>
                <br/>
                <motion.div 
                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}>
                    <Flex style={{marginLeft:10}}>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='ไม่อนุมัติ'))}>
                            <Tag color="#FB4141" >ไม่อนุมัติ</Tag></a>
                        <a onClick={()=>setGetShowData(getData.filter((item)=>item.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'))}>
                            <Tag color='#B4E50D'>ได้รับหนังสือรับรองจากอธิการบดี</Tag></a>
                    </Flex>
                </motion.div>
            </AnimatePresence>
        }
            <br/>
        <Row>
            <Col span={12}>
                <Card
                    onClick={()=>
                        setGetShowData(getData.filter((item)=>(
                            item.project_status=='ไม่อนุมัติ'
                        )))
                    }
                    hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#ff4d4f',color:'#fdfdfd',border:'none'}}>
                        <h2>ไม่อนุมัติ</h2>
                        <h1 style={{marginLeft:'8vw'}}>
                            {getData.filter((item)=>(
                                item.project_status=='ไม่อนุมัติ'
                                )).length}
                        </h1>
                </Card>
            </Col>
            <Col span={12}>
                <Card
                    onClick={()=>
                        setGetShowData(getData.filter((item)=>(
                            item.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'
                        )))
                    }
                    hoverable style={{marginLeft:5,marginRight:5,backgroundColor:'#95bf44',color:'#fdfdfd',border:'none'}}>
                        <h2>อนุมัติและส่งหนังสือรับรอง</h2>
                        <h1 style={{marginLeft:'8vw'}}>
                            {getData.filter((item)=>(
                                item.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'
                                )).length}
                        </h1>
                </Card>
            </Col>
        </Row>
        <br/>
        <Table columns={[
            {
                title:'',
                dataIndex:'action',
                key:'action',
                width:'5vw',
                render:(__, record)=><>
               <Button onClick={()=>{
                nextPage(record.Order_ID,record.head_ID,record.project_status)}}><SearchOutlined/></Button>
                </>
            },
            {
                title:'ลำดับ',
                dataIndex:'Order_ID',
                sorter: (a, b) => {
                    const Order_IDA = a.Order_ID ?  a.Order_ID : 0;
                    const Order_IDB = b.Order_ID ? b.Order_ID : 0;
                    return Order_IDA - Order_IDB;
                  },
            },
            {
                title:'รหัสเอกสาร',
                dataIndex:'projectID',
                render:(__, record)=><>
                    <p>มว.จ. {record.projectID}</p>
                </>

            },
            {
                title:'ชื่อโครงการ',
                dataIndex:'project_nameTH',
                width:'30vw',
                render:(__, record)=><>
                    <p>{record.project_nameTH}</p>
                    <p>{record.project_nameEN}</p>
                </>

            },{
                title:'ชื่อ-สกุลผู้ที่ยื่นคำขอ',
                dataIndex:'researcher_THname',
                width:'30vw',
                render:(__, record)=><>
                    <p>{record.researcher_THname}</p>
                    <p>{record.researcher_ENname}</p>
                </>
            },
            {
                title:'สังกัดที่อยู่',
                dataIndex:'researcher_facility',
                width:'30vw',
            },
            {
                title:'สถานะ',
                dataIndex:'project_status',
                render: (__: any, record: any) => {
                  let color = 'white';
                  switch (record.project_status) {
                    case 'แก้ไข':
                    case 'แก้ไขข้อมูลตามผลพิจารณา':
                      color = 'yellow';
                      break;
                  
                    case 'รอตรวจสอบจากเจ้าหน้าที่':
                    case 'รอการตรวจสอบผลพิจารณา':
                    case 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่':
                      color = 'blue';
                      break;
                  
                    case 'รอตรวจสอบจากประธานจริยธรรม':
                    case 'รอการพิจารณาจากกรรมการ':
                    case 'รอตรวจสอบผลการแก้ไขจากประธาน':
                    case 'รอพิจารณาผลการแก้ไขจากกรรมการ':
                      color = 'purple';
                      break;
                  
                    case 'รอการรับรองจากอธิการบดี':
                      color = 'lime';
                      break;
                  
                    case 'ได้รับหนังสือรับรองจากอธิการบดี':
                      color = 'green';
                      break;
                  
                    case 'ไม่อนุมัติ':
                      color = 'red';
                      break;
                  
                    default:
                      color = 'purple';
                      break;
                  }
                  
                  return <>
                    <Flex style={{margin:0}} justify='center'><Tag color={color}>{record.project_status}</Tag></Flex>
                    <br/>
                    {record.project_status =='แก้ไขข้อมูลตามผลพิจารณา'&&
                    <>{record.checkEdit=='read'&&
                        <Flex style={{margin:0}} justify='center'><Tag color='blue'>อ่านแล้ว</Tag></Flex>
                    ||
                        <Flex style={{margin:0}} justify='center'><Tag color='yellpw'>ยังไม่อ่าน</Tag></Flex>
                    }</>
                    }
                    </>;
                },
            },{
                title:'วันที่ยื่นเข้ามาล่าสุด',
                dataIndex:'last_submitted',
                sorter: (a, b) => {
                  const timeA = a.last_submitted ? moment(a.last_submitted).unix() : 0;
                  const timeB = b.last_submitted ? moment(b.last_submitted).unix() : 0;
                  return timeA - timeB;
                },
                render:(__, record)=><>
                  {moment.utc(record.last_submitted).format('DD/MM/YY HH:mm:ss')}
                </>
              },
              {
                title:'วันสิ้นสุดการแก้ไข',
                dataIndex:'edit_in',
                sorter: (a, b) => {
                  const timeA = a.edit_in ? moment(a.edit_in).unix() : 0;
                  const timeB = b.edit_in ? moment(b.edit_in).unix() : 0;
                  return timeA - timeB;
                },
                render:(__, record)=><>
                  {record?.edit_in
                    ? moment.utc(record.edit_in).format('DD/MM/YY')
                    : <>-</>}
                </>
              },
              {
                title:'วันสิ้นสุดการตรวจสอบ',
                dataIndex:'review_in',
                sorter: (a, b) => {
                  const timeA = a.review_in ? moment(a.review_in).unix() : 0;
                  const timeB = b.review_in ? moment(b.review_in).unix() : 0;
                  return timeA - timeB;
                },
                render:(__, record)=><>
                  {record?.review_in
                    ? moment.utc(record.review_in).format('DD/MM/YY')
                    : <>-</>}
                </>
              },
        ]}
        dataSource={getShowData}
        />
        </>)
    }else if(sessionStorage.getItem('role')=='president'){
        return(<>
        <h1>ยินดีต้อนรับเข้าสู่ระบบ คุณ{sessionStorage.getItem('fullname')}</h1>
        <hr/>
        <Row>
            <Col span={12}>
                <a href="/VU_HREC/RequestListView"><Card 
                    style={{marginLeft:5,marginRight:5,height:'50vh',
                    backgroundColor:'#592494',
                    color:'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    }}
                    hoverable>
                    <h1>ดูข้อมูลโครงการที่ถูกส่งเข้ามา</h1>
                </Card></a>
            </Col>
            <Col span={12}>
                <a href="/VU_HREC/CommitteeManagement"><Card 
                    style={{marginLeft:5,marginRight:5,height:'50vh',
                    backgroundColor:'#592494',
                    color:'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    }}
                    hoverable
                    >
                        
                        <h1>จัดการรายชื่อกรรมการ</h1>
                </Card></a>
            </Col>
        </Row>
        </>)
    }
    else if(sessionStorage.getItem('role')=='committee'){
        return (<>
        <h1>ยินดีต้อนรับเข้าสู่ระบบ {sessionStorage.getItem('fullname')}</h1>
            <hr/>
            <Table
                columns={[
                    {
                        title:'',
                        render:(__, record)=><>
                            <Button onClick={()=>nextPage(record.Order_ID,record.head_ID,record.project_status)}><SearchOutlined/></Button>
                        </>
                    },{
                        title:'รหัสเอกสาร',
                        dataIndex:'projectID',
                        // render:(__, record)=><>
                        //     <p>มว.จ. {record.projectID}</p>
                        // </>
        
                    },
                    {
                        title:'ชื่อโครงการ',
                        dataIndex:'project_nameTH',
                        width:'30vw',
                        render:(__, record)=><>
                            <p>{record.project_nameTH}</p>
                            <p>{record.project_nameEN}</p>
                        </>
                    },{
                        title:'ชื่อ-สกุลผู้ที่ยื่นคำขอ',
                        dataIndex:'researcher_THname',
                        width:'30vw',
                        render:(__, record)=><>
                            <p>{record.researcher_THname}</p>
                            <p>{record.researcher_ENname}</p>
                        </>
                    },{
                        title:'สถานะ',
                        dataIndex:'project_status',
                        render: (__: any, record: any) => {
                          let color = 'white';
                          switch (record.project_status) {
                            case 'แก้ไข':
                            case 'แก้ไขข้อมูลตามผลพิจารณา':
                              color = 'yellow';
                              break;
                            case 'รอตรวจสอบจากเจ้าหน้าที่' :
                                case 'รอการตรวจสอบผลพิจารณา':
                                case 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่':
                              color = 'blue';
                              break;
                            case 'รอตรวจสอบจากประธานจริยธรรม':
                                case 'รอการพิจารณาจากกรรมการ':
                                case 'รอตรวจสอบผลการแก้ไขจากประธาน':
                                case 'รอพิจารณาผลการแก้ไขจากกรรมการ':
                                case 'ประธานฯแต่งตั้งกรรมการใหม่':
                                color = 'purple';
                                break;
                            case 'รอการรับรองจากอธิการบดี' :
                              color = 'lime';
                              break;
                            case 'ได้รับหนังสือรับรองจากอธิการบดี' :
                              color = 'green';
                              break;
                            case 'ไม่อนุมัติ' :
                            color = 'red';
                                break;
                            default:
                              color = 'blue';
                              break;
                          }
                          return <Tag color={color}>{record.project_status}</Tag>;
                        },
                    },
                    {
                        title:'วันสิ้นสุดการพิจารณา',
                        dataIndex:'review_in',
                        render: (_, record) => {
                            const isOverdue = record?.review_in && moment(record.review_in).isBefore(moment(), 'day');
                            return record?.review_in ? (
                              <p style={{ color: isOverdue ? 'red' : '#ffc300' }}>
                                {moment(record.review_in).format('DD MMMM YYYY')}
                              </p>
                            ) : (
                              <>-</>
                            );
                          }
                    }
                ]}
                dataSource={getData}/>
        </>)
    }
    return (<>
        <Flex justify='space-between'><h1>รายการคำขอที่ถูกเพิ่มในระบบ</h1>
        <h1><a href={'/VU_HREC/Draft'}><Button>เพิ่มร่างคำขอ</Button></a></h1></Flex>
            <Table
                 rowKey="Order_ID"
                columns={[
                    {
                        title:'ชื่อโครงการ',
                        dataIndex:'project_nameTH',
                        width:'30vw',
                        render:(__, record)=><>
                            <p>{record.project_nameTH}</p>
                            <p>{record.project_nameEN}</p>
                        </>
                    },
                    
                    {
                        title:'สังกัด',
                        width:'10vw',
                        dataIndex:'project_fac'
                    },
                    {
                        title: 'สถานะ',
                        width: '10vw',
                        dataIndex: 'project_status',
                        render: (__: any, record: any) => {
                        let color = 'white';
                        switch (record.project_status) {
                            case 'แก้ไข':
                            case 'แก้ไขข้อมูลตามผลพิจารณา':
                              color = 'yellow';
                              break;
                          
                            case 'รอตรวจสอบจากเจ้าหน้าที่':
                            case 'รอตรวจสอบจากประธานจริยธรรม':
                            case 'รอการพิจารณาจากกรรมการ':
                            case 'รอการตรวจสอบผลพิจารณา':
                            case 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่':
                            case 'รอตรวจสอบผลการแก้ไขจากประธาน':
                            case 'รอพิจารณาผลการแก้ไขจากกรรมการ':
                            case 'ประธานฯแต่งตั้งกรรมการใหม่':
                              color = 'blue';
                              break;
                          
                            case 'รอการรับรองจากอธิการบดี':
                              color = 'lime';
                              break;
                          
                            case 'ได้รับหนังสือรับรองจากอธิการบดี':
                              color = 'green';
                              break;
                          
                            case 'ไม่อนุมัติ':
                              color = 'red';
                              break;
                          
                            default:
                              color = 'blue';
                              break;
                          }
                    
                        return <Tag color={color}>{record.project_status}</Tag>;
                        },
                    },
                    {
                        
                        title:'วันที่ยื่นล่าสุด',
                        width:'10vw',
                        dataIndex:'project_created_at',
                        render: (date: string) => moment.utc(date).format('DD/MM/YYYY'),
                        sorter: (a, b) => moment(a.project_created_at).unix() - moment(b.project_created_at).unix(),
                    },
                    {
                        
                        title:'แก้ไขภายใน',
                        width:'10vw',
                        dataIndex:'edit_in',
                        render:(__, record)=><>
                        {record?.edit_in&&<p>{moment(record?.edit_in).format('DD/MM/YYYY')}</p>||<p>-</p>}
                        </>
                    },{
                        title:'',
                        dataIndex:'action',
                        key:'action',
                        width:'5vw',
                        render:(__, record)=><>
                            <Flex>
                                <Button onClick={()=>nextPage(record.Order_ID,record.head_ID,record.project_status)}>ดู</Button>
                                &nbsp;
                                <Button type='primary' danger onClick={()=>{
                                    setDeletionMod(true)
                                    sessionStorage.setItem('Order_ID',String(record.Order_ID))
                                }} disabled={record.project_status!='แก้ไข'}><DeleteOutlined /></Button></Flex>
                        </>
                    }
                ]}
                expandable={{
                    expandedRowRender: (record) => {
                      // map statuses → step index
                      const statusMap: Record<string, number> = {
                        'แก้ไข': 0,
                        'แก้ไขข้อมูลตามผลพิจารณา': 0,
                        'รอตรวจสอบจากเจ้าหน้าที่': 1,
                        'รอตรวจสอบจากประธานจริยธรรม': 2,
                        'รอการพิจารณาจากกรรมการ': 3,
                        'รอการตรวจสอบผลพิจารณา': 1,
                        'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่': 1,
                        'รอตรวจสอบผลการแก้ไขจากประธาน': 2,
                        'รอพิจารณาผลการแก้ไขจากกรรมการ': 3,
                        'ประธานฯแต่งตั้งกรรมการใหม่': 2,
                        'รอการรับรองจากอธิการบดี': 1,
                        // 'ได้รับหนังสือรับรองจากอธิการบดี': 2,
                        // 'ไม่อนุมัติ': 2,
                      };
                  
                      const currentStep = statusMap[record.project_status] ?? 0;
                  
                      return (
                        <>
                            {record.project_status!='ได้รับหนังสือรับรองจากอธิการบดี'&&<Steps
                            current={currentStep}
                            progressDot={(dot, info) => customDot(dot, info, record,currentStep)}
                            items={StatusList}
                            />||
                            <>
                            <Flex justify='center'>
                                <Progress type="circle" percent={100} />
                            </Flex>
                            <Flex justify='center'>
                                <p>ได้รับหนังสือรับรองจากอธิการบดี</p>
                            </Flex></>}
                            {(record.project_status=='แก้ไข'||
                                record.project_status=='แก้ไขข้อมูลตามผลพิจารณา'
                            )
                            &&
                            <><Flex justify='center'>
                                <img src={filling}  width="500" height="500" alt="loading..." />
                            </Flex>
                            {(record.project_status=='แก้ไข')
                            &&<Flex justify='center'>
                                <p>กำลังแก้ไขคำขอโดยนักวิจัย</p>
                            </Flex>||(record.project_status=='แก้ไขข้อมูลตามผลพิจารณา')&&
                            <Flex justify='center'>
                                <p>กำลังแก้ไขคำขอตามผลพิจารณาโดยนักวิจัย</p>
                            </Flex>}
                            </>}

                            {(record.project_status=='รอตรวจสอบจากเจ้าหน้าที่'||
                                record.project_status=='รอตรวจสอบจากประธานจริยธรรม'||
                                record.project_status=='รอการตรวจสอบผลพิจารณา'||
                                record.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                record.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'
                            )
                            &&
                            <><Flex justify='center'>
                                <img src={checking}  width="500" height="500" alt="loading..." />
                            </Flex>
                            {(record.project_status=='รอตรวจสอบจากเจ้าหน้าที่')
                            &&<Flex justify='center'>
                                <p>กำลังตรวจสอบคำขอโดยเจ้าหน้าที่</p>
                            </Flex>
                            ||(record.project_status=='รอตรวจสอบจากประธานจริยธรรม')&&
                            <Flex justify='center'>
                                <p>กำลังตรวจสอบคำขอโดยประธานจริยธรรม</p>
                            </Flex>
                            ||(record.project_status=='รอการตรวจสอบผลพิจารณา')&&
                            <Flex justify='center'>
                                <p>กำลังตรวจสอบผลพิจารณา</p>
                            </Flex>
                            ||(record.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่')&&
                            <Flex justify='center'>
                                <p>กำลังตรวจสอบผลการแก้ไขโดยเจ้าหน้าที่</p>
                            </Flex>
                            ||(record.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน')&&
                            <Flex justify='center'>
                                <p>กำลังตรวจสอบผลการแก้ไขโดยรอตรวจสอบผลการแก้ไขจากประธาน'</p>
                            </Flex>}
                            </>}

                            {(record.project_status=='รอการพิจารณาจากกรรมการ'||
                                record.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )
                            &&
                            <><Flex justify='center'>
                                <img src={reviewing}  width="500" height="500" alt="loading..." />
                            </Flex>
                            {(record.project_status=='รอการพิจารณาจากกรรมการ')
                            &&<Flex justify='center'>
                                <p>กรรมการกำลังพิจารณาคำขอของท่าน</p>
                            </Flex>
                            ||(record.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ')&&
                            <Flex justify='center'>
                                <p>กรรมการกำลังพิจารณาผลการแก้ไขของท่าน</p>
                            </Flex>
                            }
                            </>}
                            {(record.project_status=='รอการรับรองจากอธิการบดี'||
                                record.project_status=='ได้รับหนังสือรับรองจากอธิการบดี'
                            )
                            &&
                            <><Flex justify='center'>
                                <img src={signing}  width="500" height="500" alt="loading..." />
                            </Flex>
                            {(record.project_status=='รอการรับรองจากอธิการบดี')
                            &&<Flex justify='center'>
                                <p>กำลังรอการรับรองจากอธิการบดี</p>
                            </Flex>
                            ||(record.project_status=='ได้รับหนังสือรับรองจากอธิการบดี')&&
                            <Flex justify='center'>
                                <p>คำขอนี้ได้รับหนังสือรับรองจากอธิการบดีแล้ว</p>
                            </Flex>
                           }
                            </>}
                        </>
                      );
                    },
                    rowExpandable: (record) => (record.project_status !== 'ได้รับหนังสือรับรองจากอธิการบดี'&&record.project_status !== 'ไม่อนุมัติ'),
                  }}
                dataSource={getData}
            />
            <Modal
                open={deletionMod}
                onCancel={()=>setDeletionMod(false)}
                footer={<></>}
            >
                <h2>ยืนยันการลบโครงการ</h2>
                <hr/>
                <p>ท่านต้องการลบโครงการนี้หรือไม่ หากท่านลบไปแล้วจะไม่สามารถกู้คืนได้อีก</p>
                <Flex justify='flex-end'>
                    <Button danger type='primary' onClick={()=>setDeletionMod(false)}>ยกเลิก</Button> &nbsp;
                    <Button type='primary' onClick={()=>deleteProject()}>ยืนยันการลบ</Button></Flex>

            </Modal>
    </>)
}